export interface TitleListEntry {
  id: string
  title: string
}

// The designs or texts in the menu. Shared state, so pages can refresh it
// after creating, renaming or deleting one.
function useTitleList(table: 'design' | 'texts') {
  const { $surrealRawQuery } = useNuxtApp()
  const entries = useState<TitleListEntry[]>(`${table}-list`, () => [])
  const pending = useState(`${table}-list-pending`, () => true)
  const error = useState<unknown>(`${table}-list-error`, () => null)

  async function refresh() {
    try {
      // The table permissions already limit the rows to their owner; the WHERE is a second guard.
      const [rows] = await $surrealRawQuery<[TitleListEntry[]]>(`SELECT <string> id AS id, title FROM ${table} WHERE user = $auth.id`)
      entries.value = rows.sort((a, b) => (a.title ?? '').localeCompare(b.title ?? ''))
      error.value = null
    }
    catch (err) {
      error.value = err
    }
    finally {
      pending.value = false
    }
  }

  return { entries, pending, error, refresh }
}

export function useDesignList() {
  return useTitleList('design')
}

export function useTextList() {
  return useTitleList('texts')
}
